import { render, staticRenderFns } from "./slidePage.vue?vue&type=template&id=d31f4aea&scoped=true&"
import script from "./slidePage.vue?vue&type=script&lang=js&"
export * from "./slidePage.vue?vue&type=script&lang=js&"
import style0 from "./slidePage.vue?vue&type=style&index=0&id=d31f4aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31f4aea",
  null
  
)

export default component.exports